import { getValueByPath, walkQuestionTree } from "./questionTree";

function normalizeRules(rules) {
  if (!rules) return [];
  return Array.isArray(rules) ? rules : [rules];
}

function valueMatchesRule(value, rule) {
  if (
    !rule ||
    (!Object.prototype.hasOwnProperty.call(rule, "answer") && !rule.answers)
  ) {
    return false;
  }

  const expectedValues = Array.isArray(rule.answers)
    ? rule.answers
    : [rule.answer];

  return expectedValues.some((expectedValue) => value === expectedValue);
}

function nodeMatchesRule(node, section, rule) {
  if (!node || !rule) return false;

  if (rule.identifier && node.identifier !== rule.identifier) {
    return false;
  }

  if (rule.radioGroup && node.radioGroup !== rule.radioGroup) {
    return false;
  }

  if (rule.question && node.question !== rule.question) {
    return false;
  }

  if (rule.label && node.label !== rule.label) {
    return false;
  }

  if (rule.redHeading && node.redHeading !== rule.redHeading) {
    return false;
  }

  if (
    rule.sectionNumber &&
    (!section || section.number !== rule.sectionNumber)
  ) {
    return false;
  }

  if (
    rule.sectionTitle &&
    (!section || section.title !== rule.sectionTitle)
  ) {
    return false;
  }

  return valueMatchesRule(
    getValueByPath(node, rule.answerField || "answer"),
    rule
  );
}

function ruleMatches(questions, rule) {
  let matches = false;

  (questions || []).some((question) => {
    walkQuestionTree(question, (node, section) => {
      if (!matches && nodeMatchesRule(node, section, rule)) {
        matches = true;
      }
    });

    return matches;
  });

  return matches;
}

function shouldShowTextItem(item, questions) {
  const showWhenAny = normalizeRules(item && item.showWhenAny);

  if (showWhenAny.length === 0) {
    return item && item.show !== false;
  }

  return showWhenAny.some((rule) => ruleMatches(questions, rule));
}

export function getVisibleTextItems(question) {
  if (!question || !Array.isArray(question.questions)) return [];

  return question.questions.filter((item) => item.show !== false);
}

export function syncConditionalTextQuestions(questions) {
  if (!questions || !questions.length) return questions;

  questions.forEach((question) => {
    if (
      !question ||
      question.type !== "text" ||
      !Array.isArray(question.questions)
    ) {
      return;
    }

    let hasConditionalItems = false;
    let hasVisibleItems = false;

    question.questions.forEach((item) => {
      if (!item || !item.showWhenAny) {
        if (!item || item.show !== false) {
          hasVisibleItems = true;
        }
        return;
      }

      hasConditionalItems = true;
      item.show = shouldShowTextItem(item, questions);

      if (item.show) {
        hasVisibleItems = true;
      } else {
        item.answer = "";
      }
    });

    if (hasConditionalItems && question.hideWhenNoVisibleTextItems !== false) {
      question.show = hasVisibleItems;
    }
  });

  return questions;
}
